import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react/jsx-props-no-spreading */
import { Icon } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import useStyles from './styles';
export default function Dropzone(_ref) {
  let _ref$isLarge = _ref.isLarge,
    isLarge = _ref$isLarge === void 0 ? false : _ref$isLarge;
  const classes = useStyles();
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    dropzoneState = _useState2[0],
    setDropzoneState = _useState2[1];
  const onDrop = useCallback(() => {
    // Do something with the files
  }, []);
  const onDragOver = useCallback(() => {
    setDropzoneState('drag');
  }, []);
  const onDragLeave = useCallback(() => {
    setDropzoneState('');
  }, []);
  const onDropRejected = useCallback(() => {
    setDropzoneState('error');
  }, []);
  const onDropAccepted = useCallback(() => {
    setDropzoneState('info');
    setTimeout(() => {
      setDropzoneState('success');
    }, 2500);
  }, []);
  const cancelUpload = () => {
    setDropzoneState('');
  };
  const _useDropzone = useDropzone({
      onDrop,
      onDragOver,
      onDragLeave,
      onDropRejected,
      onDropAccepted,
      maxFiles: 1,
      multiple: false,
      accept: 'image/jpeg, image/png',
      noClick: dropzoneState === 'info'
    }),
    acceptedFiles = _useDropzone.acceptedFiles,
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  const files = acceptedFiles.map(file => file.name);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(classes.dropzoneContainer, " ").concat(isLarge ? classes.largeDropzoneContainer : '')
  }, getRootProps()), /*#__PURE__*/React.createElement("input", getInputProps()), !dropzoneState && /*#__PURE__*/React.createElement("div", {
    className: classes.dropzoneContent
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "cloud-upload"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.hint
  }, "Drag and drop here or", /*#__PURE__*/React.createElement("span", null, " click to browse from your files")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.hintGrey
  }, "Supported file types are:", /*#__PURE__*/React.createElement("br", null), "image/jpeg, image/png")), dropzoneState === 'drag' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.dropzoneContent, " ").concat(classes.dropzoneDragover)
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "cloud-upload"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Drop file here to upload")), dropzoneState === 'error' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.dropzoneContent, " ").concat(classes.dropzoneError)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "warning",
    fontSize: "large"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.hint
  }, "File type is not supported"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.hintGrey
  }, "Supported file types are:", /*#__PURE__*/React.createElement("br", null), "image/jpeg, image/png")), dropzoneState === 'info' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.dropzoneContent, " ").concat(classes.dropzoneInfo)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.spinner
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "loader"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.hint
  }, files[0], " is uploading ...32%"), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    onClick: cancelUpload,
    'custom-attribute': '57-drop-zone'
  }, "Cancel upload")), dropzoneState === 'success' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.dropzoneContent, " ").concat(classes.dropzoneSuccess)
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "success"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.hint
  }, files[0], " is successfully uploaded"), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    'custom-attribute': '123-dropzone'
  }, "Re-upload file")));
}
Dropzone.propTypes = {
  isLarge: PropTypes.bool
};